module.exports = __webpack_public_path__ + "img/ye.af179051.svg";